import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import * as actions from 'store/actions';
import s from 'components/bolt/movieDetails/movieDetails.sss';
import ModelViewer from 'components/bolt/modelViewer/modelViewer';
import { joinClasses, triggerAnim, addClass, removeClass } from 'utils/utils';
import { findInVNode } from 'utils/vnode';
import { requestCameraAccess, checkCameraPermissions } from 'utils/permissionCamera';

export default class MovieDetails extends BaseComp.default {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			loadingExperience: false,
			grantedAccess: false
		};

		this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
		this.cameraAccessGranted = this.cameraAccessGranted.bind(this);
		this.cameraAccessDenied = this.cameraAccessDenied.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();

		document.addEventListener('visibilitychange', this.handleVisibilityChange);

		Store.on(actions.CAMERA_ACCESS_GRANTED, this.cameraAccessGranted);
		Store.on(actions.CAMERA_ACCESS_DENIED, this.cameraAccessDenied);
	}

	componentWillUnmount() {
		super.componentWillUnmount();

		document.removeEventListener('visibilitychange', this.handleVisibilityChange);

		Store.off(actions.CAMERA_ACCESS_GRANTED, this.cameraAccessGranted);
		Store.off(actions.CAMERA_ACCESS_DENIED, this.cameraAccessDenied);
	}

	handleVisibilityChange() {
		if (document.hidden) {
		} else {
			this.setState({ loadingExperience: true });
			removeClass(this.base, s.loadingExperience);
		}
	}

	cameraAccessGranted(stream) {
		this.setState({ grantedAccess: true });

		// Trigger AR button click!!
		clearInterval(this.delayTimer);
		this.delayTimer = setTimeout(() => {
			const arButton = document.getElementById('model-viewer-ar-button');
			arButton?.click();
		}, 500);
	}

	cameraAccessDenied(type) {
		this.setState({
			grantedAccess: false,
			loadingExperience: true
		});
		removeClass(this.base, s.loadingExperience);
	}

	async triggerButton(path, label) {
		const { loadingExperience, grantedAccess } = this.state;

		if (path === '@meetRoz') {
			this.setState({ loadingExperience: false });
			addClass(this.base, s.loadingExperience);
			if (!grantedAccess) {
				requestCameraAccess(false);
			}
			return;
		}
		super.triggerButton(path, label);
	}

	onModelLoadStarted() {
		// Store.emit(actions.TRACK_MODEL_VIEWER_LOAD_START);
	}

	onModelLoading(val) {
		// Store.emit(actions.TRACK_MODEL_VIEWER_PROGRESS, val);
	}

	onModelLoadedCompleted() {
		// Store.emit(actions.TRACK_MODEL_VIEWER_LOADED);
	}


	onModelLoaded() { }
	onModelVisibility(e) { }
	onModelStarted() { }
	onModelStopped() { }
	onARNotSupported() { }
	onModelError(e) { }

	render({ appData, client, model, type, tt, bg, buttons, cookieHeight = 0, cookieBannerOpen, dualViewEnabled, isWidget }, { grantedAccess, loadingExperience, bgVideo, backgroundStyle, quotesCarouselPosition }) {
		const imageRegionRoot = appData?.urls?.roots?.imageRegion || '';

		const base = super.render({ type, tt, bg, buttons, cookieHeight, cookieBannerOpen, dualViewEnabled, isWidget }, { bgVideo, backgroundStyle, quotesCarouselPosition });

		if (model) {
			const gltfSrc = model.gltf;
			const usdzSrc = model.usdz;
			const modelViewer = (
				<ModelViewer
					gltf={!grantedAccess ? '' : gltfSrc}
					usdz={!grantedAccess ? '' : usdzSrc}
					imageRegionRoot={imageRegionRoot}
					onModelLoaded={this.onModelLoaded}
					onModelLoadStarted={this.onModelLoadStarted}
					onModelLoading={this.onModelLoading}
					onModelLoadedCompleted={this.onModelLoadedCompleted}
					onModelStarted={this.onModelStarted}
					onModelStopped={this.onModelStopped}
					onModelVisibility={this.onModelVisibility}
					onARNotSupported={this.onARNotSupported}
					onError={this.onModelError}
				/>
			);
			const loadingSpinner = (
				<div class={joinClasses(s.spinner)} key="loader" />
			);
			this.arButton = findInVNode(base, `#ar-button`);
			if (this.arButton && grantedAccess) {
				this.arButton.children.push(modelViewer);
			}
			if (this.arButton) {
				this.arButton.children.push(loadingSpinner);
			}
		}

		return base;
	}
}